/*
 * ARSHÉ AJAX Commerce
 * Vanilla JS / Shopify Online Store 2.0
 * One calm interaction layer for cart, search, mega-menu and reveals.
 */
(function () {
  'use strict';

  var CFG = window.ARSHE_AJAX || {};
  var money = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: CFG.currency || 'INR',
    maximumFractionDigits: 0
  });

  function jsonHeaders() {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    return ids.filter(function (id, index, arr) { return id && arr.indexOf(id) === index; });
  }

  async function fetchCart() {
    var response = await fetch((CFG.cartUrl || '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function fetchSections() {
    var ids = sectionIds();
    var url = (CFG.cartUrl || '/cart') + '?sections=' + encodeURIComponent(ids.join(','));
    var response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh cart sections');
    return response.json();
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceDrawer(sectionHtml) {
    var drawer = document.querySelector('cart-drawer.arshe-ajax-cart');
    if (!drawer || !sectionHtml) return;
    var doc = parse(sectionHtml);
    var source = doc.querySelector('#ArsheCartDrawer');
    var target = drawer.querySelector('#ArsheCartDrawer');
    if (source && target) target.innerHTML = source.innerHTML;
    var sourceRoot = doc.querySelector('cart-drawer.arshe-ajax-cart');
    if (sourceRoot) drawer.classList.toggle('is-empty', sourceRoot.classList.contains('is-empty'));
  }

  function replaceCartPage(sectionHtml, id, selector) {
    if (!sectionHtml) return;
    var target = document.getElementById(id);
    if (!target) return;
    var doc = parse(sectionHtml);
    var source = doc.querySelector(selector);
    var destination = target.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  function updateHeaderCount(cart) {
    document.querySelectorAll('.arshe-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = false;
    });
    document.querySelectorAll('.arshe-ajax-cart__count').forEach(function (el) {
      el.textContent = String(cart.item_count);
    });
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.innerHTML = cart.item_count > 0 ? '<span aria-hidden="true">' + cart.item_count + '</span>' : '';
    });
    document.querySelectorAll('[data-arshe-cart-trigger]').forEach(function (el) {
      el.setAttribute('aria-label', cart.item_count ? 'Cart, ' + cart.item_count + ' items' : 'Cart');
    });

    document.querySelectorAll('[data-arshe-mobile-cart-count]').forEach(function (el) {
      el.textContent = String(cart.item_count);
      el.hidden = Number(cart.item_count || 0) === 0;
    });
  }

  function updateShipping(cart) {
    var threshold = Number(CFG.freeShippingThreshold || 99900);
    document.querySelectorAll('[data-arshe-cart-page-shipping]').forEach(function (el) {
      el.hidden = Number(cart.item_count || 0) === 0;
    });
    var subtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
    var remaining = Math.max(0, threshold - subtotal);
    var percent = Math.min(100, Math.max(0, (subtotal / threshold) * 100));
    document.querySelectorAll('[data-arshe-shipping-message]').forEach(function (el) {
      el.textContent = remaining > 0
        ? 'Add ' + money.format(remaining / 100) + ' more for free shipping.'
        : 'Free shipping unlocked.';
    });
    document.querySelectorAll('[data-arshe-shipping-progress]').forEach(function (el) {
      el.style.width = percent + '%';
    });
    document.querySelectorAll('[data-arshe-shipping-percent]').forEach(function (el) {
      el.textContent = Math.round(percent) + '%';
    });
    document.querySelectorAll('[data-arshe-cart-total], [data-arshe-cart-total-page]').forEach(function (el) {
      el.textContent = money.format(subtotal / 100);
    });

    var pageCount = document.querySelector('.template-cart .arshe-cart-page__count, .template-cart .arshe-cart-page__title .arshe-cart-page__count');
    if (pageCount) pageCount.textContent = String(Number(cart.item_count || 0));

    var pageMessage = document.querySelector('[data-arshe-cart-page-shipping-message]');
    var pagePercent = document.querySelector('[data-arshe-cart-page-shipping-percent]');
    var pageProgress = document.querySelector('[data-arshe-cart-page-shipping-progress]');
    if (pageMessage) {
      pageMessage.textContent = remaining > 0
        ? 'ADD ' + money.format(remaining / 100) + ' MORE FOR FREE SHIPPING.'
        : 'FREE SHIPPING UNLOCKED';
    }
    if (pagePercent) pagePercent.textContent = Math.round(percent) + '%';
    if (pageProgress) pageProgress.style.width = percent + '%';
  }

  function setCheckoutState(cart) {
    document.querySelectorAll('[data-arshe-checkout], [data-arshe-cart-page-checkout]').forEach(function (el) {
      var empty = Number(cart.item_count || 0) === 0;
      el.classList.toggle('is-disabled', empty);
      el.setAttribute('aria-disabled', empty ? 'true' : 'false');
      el.tabIndex = empty ? -1 : 0;
      if ('disabled' in el) el.disabled = empty;
    });
  }

  async function refreshCartUI(cart, sections) {
    cart = cart || await fetchCart();

    /* Shopify cart JSON is the canonical state. Section HTML is only the
       presentation layer and may fail independently, so never let a section
       failure turn a valid cart into a stale visual state. */
    if (!sections) {
      try {
        sections = await fetchSections();
      } catch (error) {
        console.error('[ARSHÉ] cart sections refresh', error);
        sections = null;
      }
    }

    if (sections) {
      replaceDrawer(sections['cart-drawer']);

      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');

      if (items && items.dataset.id && sections[items.dataset.id]) {
        replaceCartPage(sections[items.dataset.id], 'main-cart-items', '.js-contents');
      }
      if (footer && footer.dataset.id && sections[footer.dataset.id]) {
        replaceCartPage(sections[footer.dataset.id], 'main-cart-footer', '.js-contents');
      }

      var cartItemsRoot = document.querySelector('.template-cart .arshe-cart-page');
      var cartFooterRoot = document.getElementById('main-cart-footer');
      var empty = Number(cart.item_count || 0) === 0;
      if (cartItemsRoot) cartItemsRoot.classList.toggle('is-empty', empty);
      if (cartFooterRoot) cartFooterRoot.classList.toggle('is-empty', empty);
    }

    updateHeaderCount(cart);
    updateShipping(cart);
    setCheckoutState(cart);
    updateRecommendations(cart);
    initCartFloatingSafety();
    return cart;
  }

  function setButtonBusy(button, busy, label) {
    if (!button) return;
    if (busy) {
      if (!button.dataset.arsheOriginalText) button.dataset.arsheOriginalText = button.textContent.trim();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) button.querySelector('span') ? button.querySelector('span').textContent = label : button.textContent = label;
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (button.dataset.arsheOriginalText) {
        var span = button.querySelector('span');
        if (span) span.textContent = button.dataset.arsheOriginalText;
        else button.textContent = button.dataset.arsheOriginalText;
        delete button.dataset.arsheOriginalText;
      }
    }
  }

  async function addToCart(form, submitter, options) {
    options = options || {};
    var formData = new FormData(form);
    var variantId = formData.get('id');
    if (!variantId) return;
    if (!formData.get('quantity')) formData.set('quantity', '1');
    formData.append('sections', sectionIds().join(','));
    formData.append('sections_url', window.location.pathname);

    if (!beginCartMutation(submitter)) return;
    setButtonBusy(submitter, true, 'Adding…');
    try {
      var response = await fetch(CFG.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      var data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add to cart');

      var freshCart = await fetchCart();
      var freshSections = data.sections || await fetchSections();
      await refreshCartUI(freshCart, freshSections);

      if (options.buyNow) {
        window.location.assign(CFG.checkoutUrl || '/checkout');
      } else if (options.openCart !== false) {
        openCart();
      }
      announce('Added to cart.');
    } catch (error) {
      console.error('[ARSHÉ] add to cart', error);
      showToast(error.message || 'Something went wrong.');
    } finally {
      setButtonBusy(submitter, false);
      endCartMutation(submitter);
    }
  }

  async function changeLine(identifier, quantity, trigger) {
    if (!identifier || Number.isNaN(Number(quantity))) return;
    if (!beginCartMutation(trigger)) return;

    var key = String(identifier);
    var escaped = (window.CSS && CSS.escape) ? CSS.escape(key) : key.replace(/["\\]/g, '\\$&');
    var drawerRow = document.querySelector('.arshe-ajax-cart__item[data-line-key="' + escaped + '"]');
    var pageRow = document.querySelector('.template-cart .arshe-cart-item[data-line-key="' + escaped + '"]');
    var row = drawerRow || pageRow;

    if (!row && /^\d+$/.test(key)) {
      row = document.querySelector('.arshe-ajax-cart__item[data-line="' + key + '"]') ||
        document.getElementById('CartItem-' + key);
    }
    if (row) row.classList.add('is-updating', 'arshe-cart-updating');

    try {
      var numericQuantity = Math.max(0, Math.floor(Number(quantity)));
      var payload = { quantity: numericQuantity };

      /* Prefer Shopify's immutable line-item key. Only fall back to the
         numeric line when the current DOM genuinely has no key. */
      var lineKey = row && row.dataset && row.dataset.lineKey;
      if (lineKey) payload.id = lineKey;
      else if (/^\d+$/.test(key)) payload.line = Number(key);
      else payload.id = key;

      payload.sections = sectionIds();
      payload.sections_url = window.location.pathname;

      var response = await fetch(CFG.cartChangeUrl || '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: jsonHeaders(),
        body: JSON.stringify(payload)
      });

      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || data.status || data.errors) {
        throw new Error(data.description || data.message || 'Cart update failed');
      }

      /* Never trust stale DOM or stale section HTML. The mutation response is
         followed by a fresh cart read and a fresh section render. */
      var freshCart = await fetchCart();
      var freshSections = data.sections || await fetchSections();
      await refreshCartUI(freshCart, freshSections);

      document.dispatchEvent(new CustomEvent('arshe:cart:updated', {
        detail: freshCart
      }));
      announce(numericQuantity === 0 ? 'Cart item removed.' : 'Cart updated.');
    } catch (error) {
      console.error('[ARSHÉ] cart change', error);
      showToast('Unable to update cart. Please try again.');
      try {
        var recoveredCart = await fetchCart();
        var recoveredSections = await fetchSections().catch(function () { return null; });
        await refreshCartUI(recoveredCart, recoveredSections);
      } catch (refreshError) {
        console.error('[ARSHÉ] cart recovery', refreshError);
      }
    } finally {
      if (row) row.classList.remove('is-updating', 'arshe-cart-updating');
      endCartMutation(trigger);
    }
  }

  async function updateCartViaUpdateEndpoint(updates) {
    var response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: jsonHeaders(),
      body: JSON.stringify({ updates: updates })
    });
    var data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'Cart update failed');
    await refreshCartUI(data, data.sections || null);
  }

  function getDrawer() { return document.querySelector('cart-drawer.arshe-ajax-cart'); }

  function openCart() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('arshe-cart-open');
    document.body.classList.add('arshe-cart-open');
    var panel = drawer.querySelector('.arshe-ajax-cart__panel');
    window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 40);
    updateRecommendations();
  }

  function closeCart() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('arshe-cart-open');
    document.body.classList.remove('arshe-cart-open');
  }

  var cartFloatingObserver = null;

  function initCartFloatingSafety() {
    if (cartFloatingObserver) {
      cartFloatingObserver.disconnect();
      cartFloatingObserver = null;
    }
    if (!document.body.classList.contains('template-cart')) return;
    var finder = document.querySelector('.arshe-scent-finder__fab');
    var checkout = document.querySelector('[data-arshe-cart-page-checkout]');
    if (!finder || !checkout || !window.IntersectionObserver) return;

    cartFloatingObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.body.classList.toggle('arshe-cart-checkout-visible', entry.isIntersecting);
      });
    }, { threshold: 0.15 });

    cartFloatingObserver.observe(checkout);
  }

  function announce(message) {
    var live = document.getElementById('arshe-ajax-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'arshe-ajax-live';
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = message;
  }

  var toastTimer;
  function showToast(message) {
    var toast = document.querySelector('[data-arshe-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'arshe-ajax-toast';
      toast.setAttribute('data-arshe-toast', '');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
  }

  function productImageUrl(url, width) {
    if (!url) return '';
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    return url + joiner + 'width=' + width + '&format=webp&quality=80';
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  var recommendationsRequest = null;
  var cartMutationBusy = false;

  function beginCartMutation(trigger) {
    if (cartMutationBusy) return false;
    cartMutationBusy = true;
    if (trigger) {
      trigger.dataset.arsheBusy = 'true';
      trigger.setAttribute('aria-busy', 'true');
      trigger.disabled = true;
    }
    return true;
  }

  function endCartMutation(trigger) {
    if (trigger) {
      delete trigger.dataset.arsheBusy;
      trigger.removeAttribute('aria-busy');
      trigger.disabled = false;
    }
    cartMutationBusy = false;
  }
  async function updateRecommendations(cart) {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-arshe-recommendations]'));
    if (!boxes.length) return;

    cart = cart || await fetchCart().catch(function () { return null; });
    if (!cart || !cart.items || !cart.items.length) {
      boxes.forEach(function (box) { box.hidden = true; });
      return;
    }

    var currentIds = cart.items.map(function (item) { return Number(item.product_id); });
    var productId = Number(cart.items[0].product_id);
    if (!productId) return;

    boxes.forEach(function (box) { box.hidden = false; });
    if (recommendationsRequest) recommendationsRequest.abort();
    recommendationsRequest = new AbortController();

    try {
      var response = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related', {
        signal: recommendationsRequest.signal,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('recommendations unavailable');

      var data = await response.json();
      var products = (data.products || [])
        .filter(function (product) { return currentIds.indexOf(Number(product.id)) === -1; })
        .slice(0, 3);

      boxes.forEach(function (box) {
        var grid = box.querySelector('[data-arshe-recommendation-grid]');
        if (!grid) return;
        if (!products.length) {
          box.hidden = true;
          return;
        }

        grid.innerHTML = products.map(function (product) {
          var variant = product.variants && product.variants[0];
          var price = Number(product.price || product.price_min || 0);
          var image = product.featured_image || product.images && product.images[0];

          return '<article class="arshe-ajax-cart__recommendation">' +
            '<a href="' + escapeHTML(product.url) + '" class="arshe-ajax-cart__recommendation-media">' +
            (image ? '<img src="' + escapeHTML(productImageUrl(image, 240)) + '" width="240" height="240" loading="lazy" alt="' + escapeHTML(product.title) + '">' : '') +
            '</a>' +
            '<div class="arshe-ajax-cart__recommendation-info">' +
            '<a href="' + escapeHTML(product.url) + '" class="arshe-ajax-cart__recommendation-title">' + escapeHTML(product.title) + '</a>' +
            '<span>' + money.format(price / 100) + '</span>' +
            (variant && variant.available ? '<button type="button" data-arshe-upsell-add data-variant-id="' + Number(variant.id) + '">+ Add</button>' : '') +
            '</div></article>';
        }).join('');
      });
    } catch (error) {
      if (error.name !== 'AbortError') {
        boxes.forEach(function (box) { box.hidden = true; });
      }
    }
  }

  function initCartElement() {
    if (customElements.get('cart-drawer')) return;
    class ArsheCartDrawer extends HTMLElement {
      open(trigger) { if (trigger) this._trigger = trigger; openCart(); }
      close() { closeCart(); }
      setActiveElement(element) { this._trigger = element; }
      getSectionsToRender() { return [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }]; }
      renderContents(state) { refreshCartUI(null, state && state.sections ? state.sections : null).then(openCart); }
    }
    customElements.define('cart-drawer', ArsheCartDrawer);
  }

  function initCartEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form');
      if (!form || form.dataset.arsheAjaxHandled === 'true') return;
      var submitter = event.submitter || form.querySelector('[name="add"][type="submit"], button[type="submit"]');
      var variant = form.querySelector('[name="id"]');
      var isAddForm = variant && (form.matches('[data-type="add-to-cart-form"]') || /\/cart\/add/.test(form.getAttribute('action') || '') || (submitter && submitter.name === 'add'));
      if (!isAddForm) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form, submitter);
    }, true);

    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-arshe-cart-close]');
      if (close) { event.preventDefault(); closeCart(); return; }

      var cartTrigger = event.target.closest('[data-arshe-cart-trigger]');
      if (cartTrigger && getDrawer() && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !document.body.classList.contains('template-cart')) {
        event.preventDefault();
        openCart(cartTrigger);
        return;
      }

      var qty = event.target.closest('[data-arshe-cart-qty]');
      if (qty) {
        event.preventDefault();
        var drawerRow = qty.closest('[data-line]');
        if (!drawerRow) return;
        var value = Number(drawerRow.querySelector('[data-arshe-cart-qty-value]')?.textContent || 1);
        var next = qty.dataset.arsheCartQty === 'plus' ? value + 1 : Math.max(0, value - 1);
        changeLine(drawerRow.dataset.lineKey || drawerRow.dataset.line, next, qty);
        return;
      }

      var remove = event.target.closest('[data-arshe-cart-remove]');
      if (remove) {
        event.preventDefault();
        var removeRow = remove.closest('[data-line]');
        if (removeRow) changeLine(removeRow.dataset.lineKey || removeRow.dataset.line, 0, remove);
        return;
      }

      var pageQty = event.target.closest('.template-cart [data-arshe-cart-page-qty]');
      if (pageQty) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var pageInput = pageQty.closest('.arshe-cart-item')?.querySelector('.arshe-cart-item__quantity-input');
        if (!pageInput) return;
        var line = pageInput.dataset.line;
        var key = pageInput.dataset.quantityLineKey || line;
        var current = Number(pageInput.value);
        var step = Math.max(1, Number(pageInput.step || 1));
        if (!Number.isFinite(current)) return;
        var nextPage = pageQty.dataset.arsheCartPageQty === 'plus' ? current + step : Math.max(0, current - step);
        changeLine(key, nextPage, pageQty);
        return;
      }

      var pageRemove = event.target.closest('.template-cart [data-arshe-cart-page-remove]');
      if (pageRemove) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var removeKey = pageRemove.dataset.lineKey;
        if (removeKey) changeLine(removeKey, 0, pageRemove);
        return;
      }

      var upsell = event.target.closest('[data-arshe-upsell-add]');
      if (upsell) {
        event.preventDefault();
        var id = Number(upsell.dataset.variantId);
        if (!id || upsell.disabled) return;
        if (!beginCartMutation(upsell)) return;
        var fd = new FormData();
        fd.append('id', String(id));
        fd.append('quantity', '1');
        fd.append('sections', sectionIds().join(','));
        fd.append('sections_url', window.location.pathname);
        fetch(CFG.cartAddUrl || '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || 'Unable to add'); return d; }); })
          .then(async function (data) {
            var freshCart = await fetchCart();
            var freshSections = data.sections || await fetchSections();
            return refreshCartUI(freshCart, freshSections);
          })
          .catch(function (e) { showToast(e.message || 'Unable to add'); })
          .finally(function () { endCartMutation(upsell); });
        return;
      }
    }, true);

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.template-cart .arshe-cart-item__quantity-input');
      if (!input) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      var raw = input.value.trim();
      var parsed = Number(raw);
      var min = Number(input.min || 1);
      var max = input.max ? Number(input.max) : Infinity;
      var step = Math.max(1, Number(input.step || 1));

      if (raw === '' || !Number.isFinite(parsed) || parsed < 0 || parsed > max) {
        input.value = input.defaultValue;
        return;
      }

      var quantity = Math.max(0, Math.min(max, Math.round(parsed / step) * step));
      if (quantity > 0 && quantity < min) quantity = min;
      input.value = quantity;
      changeLine(input.dataset.quantityLineKey || input.dataset.line, quantity, input);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeCart();
        closeSearch();
        closeMega();
      }
    });
  }

  var predictiveTimer = null;
  var predictiveController = null;
  function closeSearch() {
    var overlay = document.querySelector('[data-arshe-search]');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    var trigger = document.querySelector('[data-arshe-search-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('arshe-search-open');
  }

  function openSearch() {
    var overlay = document.querySelector('[data-arshe-search]');
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('arshe-search-open');
    var trigger = document.querySelector('[data-arshe-search-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var input = overlay.querySelector('[data-arshe-predictive-input]');
    window.setTimeout(function () { if (input) input.focus(); }, 100);
  }

  async function predictiveSearch(input) {
    var box = input.closest('[data-arshe-search]')?.querySelector('[data-arshe-predictive-results]');
    if (!box) {
      var predictiveHost = input.closest('predictive-search');
      box = predictiveHost?.querySelector('[data-predictive-search]');
    }
    if (!box) return;
    var query = input.value.trim();
    if (query.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    if (predictiveController) predictiveController.abort();
    predictiveController = new AbortController();
    box.hidden = false;
    box.innerHTML = '<div class="arshe-search-results-loading"><span></span><span></span><span></span></div>';
    clearTimeout(predictiveTimer);
    predictiveTimer = setTimeout(async function () {
      try {
        var base = CFG.predictiveSearchUrl || '/search/suggest';
        var url = base + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
        var response = await fetch(url, { signal: predictiveController.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        var data = await response.json();
        var products = data.resources?.results?.products || [];
        if (!products.length) {
          box.innerHTML = '<div class="arshe-search-empty">No fragrance found.<a href="' + CFG.searchUrl + '?q=' + encodeURIComponent(query) + '">View full search →</a></div>';
          return;
        }
        box.innerHTML = '<div class="arshe-search-results-heading"><span>FRAGRANCES</span><a href="' + CFG.searchUrl + '?q=' + encodeURIComponent(query) + '">View all →</a></div>' +
          products.map(function (product) {
            var image = product.image || (product.images && product.images[0]);
            var price = Number(product.price_min || product.price || 0);
            return '<a class="arshe-search-result" href="' + escapeHTML(product.url) + '">' +
              '<span class="arshe-search-result__media">' + (image ? '<img src="' + escapeHTML(productImageUrl(image, 180)) + '" width="180" height="180" loading="lazy" alt="' + escapeHTML(product.title) + '">' : '') + '</span>' +
              '<span class="arshe-search-result__copy"><strong>' + escapeHTML(product.title) + '</strong><small>Extrait de Parfum</small><span>' + money.format(price / 100) + '</span></span>' +
              '<span class="arshe-search-result__arrow">→</span>' +
            '</a>';
          }).join('');
      } catch (error) {
        if (error.name !== 'AbortError') box.hidden = true;
      }
    }, 300);
  }

  function initSearch() {
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-arshe-search-open]');
      if (open) { event.preventDefault(); openSearch(); return; }
      if (event.target.closest('[data-arshe-search-close]')) { event.preventDefault(); closeSearch(); }
    });
    document.addEventListener('input', function (event) {
      var input = event.target.closest('[data-arshe-predictive-input], .template-search input[type="search"][name="q"]');
      if (!input) return;
      if (input.matches('.template-search input[type="search"][name="q"]')) {
        var host = input.closest('predictive-search') || input.parentElement;
        var box = host && host.querySelector('[data-predictive-search]');
        if (box && !box.dataset.arshePredictiveEnhanced) {
          box.dataset.arshePredictiveEnhanced = 'true';
          box.classList.add('arshe-predictive-enhanced');
          input.setAttribute('data-arshe-predictive-input', '');
        }
      }
      event.stopImmediatePropagation();
      predictiveSearch(input);
    });
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-arshe-predictive-form]');
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector('[data-arshe-predictive-input]');
      var query = input?.value.trim();
      if (query) window.location.href = (CFG.searchUrl || '/search') + '?q=' + encodeURIComponent(query);
    });
  }

  function closeMega() {
    document.querySelectorAll('[data-arshe-mega-trigger]').forEach(function (wrap) {
      wrap.classList.remove('is-open');
      var button = wrap.querySelector('button');
      if (button) button.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('[data-arshe-mega]').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function initMegaMenu() {
    // DESKTOP ONLY.
    // Important: the mega menu is physically moved to <body> before it opens.
    // This prevents fixed/sticky/transform/filter contexts from clipping it.
    // Nothing in the mobile navigation is changed.
    var desktop = window.matchMedia('(min-width: 900px)').matches;
    if (!desktop) return;

    var panel = document.querySelector('[data-arshe-mega]');
    if (!panel) return;

    // Make the menu a true body-level portal. Running this once is enough.
    if (panel.parentNode !== document.body) {
      document.body.appendChild(panel);
    }
    panel.classList.add('arshe-mega-menu--portal');

    document.querySelectorAll('[data-arshe-mega-trigger]').forEach(function (wrap) {
      var button = wrap.querySelector('button');
      if (!button) return;

      var timer;

      function positionPanel() {
        var header = document.querySelector('.arshe-header');
        var rect = header ? header.getBoundingClientRect() : { bottom: 76 };
        panel.style.top = Math.max(0, Math.round(rect.bottom)) + 'px';
        panel.style.left = '0px';
        panel.style.right = 'auto';
        panel.style.width = '100vw';
      }

      function setHeaderVisibleForMenu() {
        // If the cinematic preloader/editor state has left the desktop header
        // hidden, opening Shop must never make the navigation disappear.
        document.body.classList.remove('luxe-loading', 'luxe-flying');
        document.body.classList.add('luxe-header-visible');
        var header = document.querySelector('.arshe-header');
        if (header) {
          header.style.opacity = '1';
          header.style.visibility = 'visible';
          header.style.filter = 'none';
        }
      }

      function setOpen(open) {
        clearTimeout(timer);
        if (open) {
          setHeaderVisibleForMenu();
          positionPanel();
          wrap.classList.add('is-open');
          panel.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          wrap.classList.remove('is-open');
          panel.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        }
      }

      function open() { setOpen(true); }

      function closeSoon() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!wrap.matches(':hover') && !panel.matches(':hover')) setOpen(false);
        }, 180);
      }

      if (button.dataset.arsheMegaBound === 'true') return;
      button.dataset.arsheMegaBound = 'true';

      wrap.addEventListener('mouseenter', open);
      wrap.addEventListener('mouseleave', closeSoon);
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', closeSoon);

      button.addEventListener('focus', open);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(!panel.classList.contains('is-open'));
      });

      document.addEventListener('click', function (event) {
        if (!wrap.contains(event.target) && !panel.contains(event.target)) setOpen(false);
      });

      window.addEventListener('resize', function () {
        if (panel.classList.contains('is-open')) positionPanel();
      }, { passive: true });

      window.addEventListener('scroll', function () {
        if (panel.classList.contains('is-open')) positionPanel();
      }, { passive: true });
    });
  }

  function initReveals() {
    var selectors = [
      '.arshe-hero', '.arshe-collection-v2', '.arshe-discovery', '.arshe-testimonials',
      '.arshe-story', '.arshe-story-teaser', '.arshe-ritual', '.arshe-newsletter',
      '.arshe-instagram', '.arshe-collection', '.arshe-product', '.arshe-home-section'
    ].join(',');
    var elements = document.querySelectorAll(selectors);
    if (!elements.length || !('IntersectionObserver' in window)) return;
    elements.forEach(function (el) { el.setAttribute('data-arshe-reveal', ''); });
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('arshe-is-visible'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    elements.forEach(function (el) { observer.observe(el); });
  }

  function initCartTriggerAccessibility() {
    document.querySelectorAll('[data-arshe-cart-trigger]').forEach(function (link) {
      link.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !document.body.classList.contains('template-cart')) {
          event.preventDefault(); openCart(link);
        }
      });
    });
  }

  /* One public commerce surface for other ARSHÉ components. PDP sticky CTAs
     delegate here instead of creating a second /cart/add.js controller. */
  window.ARSHE_CART = {
    add: function (form, button, options) { return addToCart(form, button, options || {}); },
    change: changeLine,
    refresh: refreshCartUI
  };

  function init() {
    initCartElement();
    initCartEvents();
    initSearch();
    initMegaMenu();
    initReveals();
    initCartTriggerAccessibility();
    initCartFloatingSafety();
    fetchCart().then(function (cart) { updateHeaderCount(cart); updateShipping(cart); setCheckoutState(cart); }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
